import { AccessControlCheck } from "@/auth/AccessControlCheck"

const CheckAccess = (permission) => {
  return AccessControlCheck.checkPermission(permission);
};

const createAccessCheckPayload = (permission) => {
  return { callback: CheckAccess, value: permission }
}

const items = [
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: "icon-speedometer",
    access_check: true,
  },
  {
    name: "Customers",
    url: "/customer",
    icon: "fal fa-list",
    attributes: {
      exact: true,
    },
    access_check: createAccessCheckPayload("list customer"),
  },
  {
    name: "Projects",
    url: "/projects",
    icon: "fal fa-boxes",
    access_check: createAccessCheckPayload("list project"),
  },
  {
    name: "Submissions",
    url: "/submissions",
    icon: "fal fa-box",
    access_check: createAccessCheckPayload("list submission"),
  },
  {
    name: "Samples",
    url: "/samples",
    icon: "fal fa-box-open",
    attributes: {
      exact: true,
    },
    access_check: createAccessCheckPayload("list sample"),
  },
  {
    name: "Receive",
    url: "/samples/receive",
    icon: "fal fa-truck",
    attributes: {
      exact: true,
    },
    access_check: true,
  },
  {
    name: "Schedules",
    url: "/schedules",
    icon: "fal fa-calendar",
    access_check: createAccessCheckPayload("list schedule"),
  },
  // {
  //   name: "Work Groups",
  //   url: "/workgroups",
  //   icon: "fal fa-address-book",
  //   access_check: createAccessCheckPayload("list work group"),
  // },
  {
    name: "Result Manager",
    url: "/result-manager",
    icon: "far fa-file-edit",
    access_check: createAccessCheckPayload("list analyte result")
  },
  {
    name: "Results",
    url: "/results",
    icon: "fal fa-file-excel",
    access_check: true,
    // access_check: createAccessCheckPayload('list result')
  },
  {
    name: "Orders",
    url: "/orders",
    icon: "fal fa-shopping-cart",
    access_check: true,
    // access_check: createAccessCheckPayload('list order')
  },
  {
    name: "Instrument Runner",
    url: "/instrument-runner",
    icon: "fal fa-cogs",
    access_check: true,
  },
];

export default {
  items: items.filter(({ access_check }) => access_check)
}
